export default "__VITE_ASSET__CB7ieljf__"